import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'
import { Culture } from '@/types/culture'
import { Treatment } from '@/types/treatment'

export interface DiagnosisReportIssue {
  title: string
  description: string
  name: string
}

export interface DiagnosisReport {
  id: string
  diagnosis_id: string
  created_at: string
  issues: DiagnosisReportIssue[]
}

export async function getLatestDiagnosisReport(
  treatment: Treatment,
  culture: Culture,
  diagnosisId: string,
  { signal }: AxiosRequestConfig = {},
) {
  const { data } = await companiesApi.get<DiagnosisReport>(
    apiRoutes.getLatestDiagnosisReport(treatment, culture, diagnosisId),
    { signal },
  )

  return data
}
